import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../Store';

import { StepOne } from './step_one';
import { StepTwo } from './step_two';
import { StepThree } from './step_three';
import { StepFour } from './step_four';
import './register.scss';

/**********************************************************************
 * Component:  RegistrationStepsTemplate
 * Purpose:    Sets up all the main Registration steps that the user progressed
 *             through.  Contains Registration Progress Bar
 *
 * Props:       presetStep - initial step in registration process for this user
 *                           (can be passed via login in URL Parameter)
 *              user -  user data store
 *              actions - store actions (apis)
 *
 * APIs used:   None
 *
 *  Notes:
 */
const RegistrationStepsTemplate = ({ presetStep = 1, user }) => {
    const stepFromUrl = new URLSearchParams(document.location.search).get('step');
    const initialStep = stepFromUrl ? stepFromUrl : presetStep;
    const [step, setStep] = useState({ step: initialStep });

    let initialVerifyFields = {
        firstname: user.player.firstname ? user.player.firstname : '',
        lastname: user.player.lastname ? user.player.lastname : '',
        birthdate: user.player.birthdate ? user.player.birthdate : '',
        address: user.player.address ? user.player.address : '',
        phone: user.player.phone ? user.player.phone : '',
        email: user.player.phone ? user.player.email : '',
        ssn: '',
    };

    const [verifyFields, setVerifyFields] = useState(initialVerifyFields);

    //***********************************************************************************
    // Check the user store to see if any data is in there - might be true if we got here
    // via login, else - these fields are empty for a new registration.
    useEffect(() => {
        let newVerifyFields = {
            firstname: user.player.firstname ? user.player.firstname : '',
            lastname: user.player.lastname ? user.player.lastname : '',
            birthdate: user.player.birthdate ? user.player.birthdate : '',
            address: user.player.address ? user.player.address : ' ',
            phone: user.player.phone ? user.player.phone : ' ',
            email: user.player.phone ? user.player.email : '',
            ssn: '',
        };
        if (step.step === initialStep) {
            setVerifyFields(newVerifyFields);
        }
    }, [user]);

    return (
        <div className='my-3'>
            <RegistrationProgressBar step={step} />
            <form className='theme-form'>
                <StepOne step={step} user={user} setStep={setStep} verifyFields={verifyFields} setVerifyFields={setVerifyFields} />
                <StepTwo step={step} user={user} setStep={setStep} verifyFields={verifyFields} setVerifyFields={setVerifyFields} />
                <StepThree step={step} user={user} setStep={setStep} verifyFields={verifyFields} setVerifyFields={setVerifyFields} />
            </form>
            <StepFour step={step} user={user} setStep={setStep} verifyFields={verifyFields} setVerifyFields={setVerifyFields} />
        </div>
    );
};

/**********************************************************************
 * Component:  RegistrationProgressBar
 * Purpose:    Keeps a record of where user is in regitstation process
 *
 * Props:      step - what step user is in the process.
 *
 * APIs used:   None
 *
 *  Notes:
 */
const RegistrationProgressBar = ({ step }) => {
    return (
        <div className='registration-progress-bar'>
            <div className={`step step1 ${step.step == 1 ? 'active' : ''}`}>
                <div className='circle'>1</div>
                <span className='step-title'>Account</span>
            </div>
            <div className={`step step2 ${step.step == 2 ? 'active' : ''}`}>
                <div className='circle'>2</div>
                <span className='step-title'>Identification</span>
            </div>
            <div className={`step step3 ${step.step == 3 ? 'active' : ''}`}>
                <div className='circle'>3</div>
                <span className='step-title'>Contact Info</span>
            </div>
            <div className={`step step4 ${step.step == 4 ? 'active' : ''}`}>
                <div className='circle'>4</div>
                <span className='step-title'>Verify</span>
            </div>
        </div>
    );
};

const RegistrationSteps = connect(mapStateToProps, mapDispatchToProps)(RegistrationStepsTemplate);

export { RegistrationSteps };
